import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "selected"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { useTableContext } from '../TableContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledTRow = styled.tr.withConfig({
  displayName: "TableRow__StyledTRow"
})(({
  theme,
  $selected,
  $cssStyles,
  $disableHover
}) => {
  return Object.assign({
    transition: `background-color 150ms ease-out`
  }, !$disableHover && {
    '&:hover': {
      backgroundColor: theme.color['fill-field-hover']
    }
  }, $selected && {
    [$disableHover ? '&' : '&, &:hover']: {
      backgroundColor: theme.color['fill-field-pressed']
    }
  }, $cssStyles);
});
export const TableRow = _ref => {
  let {
      children,
      selected
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    tokenProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    disableHover
  } = useTableContext();
  return /*#__PURE__*/_jsx(StyledTRow, Object.assign({}, domProps, callbackProps, restProps, {
    $selected: selected,
    $cssStyles: cssStyles,
    $disableHover: disableHover,
    children: children
  }));
};
TableRow.displayName = 'TableRow';